module.exports = __webpack_public_path__ + "img/declared-value.d75f84a1.svg";